import { defineMessages } from 'react-intl';

const scope = 'get_support_entry_input';

export default defineMessages({
  sendQuery: {
    id: `${scope}.send_query`,
    defaultMessage: 'Send',
  },
  questionInputPlaceholder: {
    id: `${scope}.question_input_placeholder`,
    defaultMessage: 'Type your question here',
  },
  feedbackInputPlaceholder: {
    id: `${scope}.feedback_input_placeholder`,
    defaultMessage: 'Type your feedback here',
  },
  suggestionQueryList: {
    id: `${scope}.suggestion_query_list`,
    defaultMessage: 'Select from auto suggestion list',
  },
  suggestionListAvailableResults: {
    id: `${scope}.suggestion_list_available_results`,
    defaultMessage:
      '{count, plural, one{# available result} other{# available results}}.',
  },
  suggestionListNoAvailableResults: {
    id: `${scope}.suggestion_list_no_available_results`,
    defaultMessage: 'Zero results, please try another query.',
  },
});
